import React, { useState, useEffect } from 'react';
import './index.scss';
import Sections from './sections';
import { Form, FormControl } from 'react-bootstrap';
import { getRandom, getRandomRange } from '../../utils';
import useDebounce from '../../hooks/useDebounce';
import { getAllKata, getMyKata as getMyKataService } from '../../services/apiService';
import Loading from '../loading';
import { levelList, htmlSummaryRange } from '../../constants';
import { useApp } from '../../contexts/useApp';
import { kataType as KataType } from '../../constants';

const Home = () => {
  const { state } = useApp();
  const [debounce] = useDebounce();
  const [searchValue, setSearchValue] = useState('');
  const [keyword, setKeyWord] = useState('');
  const [level, setLevel] = useState('0');
  const [mCards, setMCards] = useState([]);
  const [initCards, setInitCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [myKata, setMyKata] = useState('all');

  const getMyKata = async e => {
    const kataType = e.target.value;
    setMyKata(kataType);

    setIsLoading(true);
    try {
      let data;
      setLevel('');
      if (kataType === KataType.ALL) {
        data = await getAllKata();
      } else {
        data = await getMyKataService();
      }

      const cards = data.data.map(card => ({
        ...card,
        randomType: getRandom(4),
        randomNum: getRandom(4),
        contentCount: getRandomRange(htmlSummaryRange[0], htmlSummaryRange[1]),
      }));
      setInitCards(cards);
      setMCards(cards);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const { data } = await getAllKata();
        const cards = data.map(card => ({
          ...card,
          randomType: getRandom(4),
          randomNum: getRandom(4),
          contentCount: getRandomRange(20, 60),
        }));
        setInitCards(cards);
        setMCards(cards);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);
  const filterByLevel = level => {
    setSearchValue(''); // clear other filter
    setLevel(level);
    if (!level) return setMCards(initCards);
    setMCards(initCards.filter(card => card.level === Number(level)));
  };

  const search = e => {
    setLevel(''); // clear other filter
    setSearchValue(e.target.value);
    if (!e.target.value) return setMCards(initCards);
    debounce(() => {
      const kw = e.target.value.trim().toLowerCase();
      setKeyWord(kw);
      setMCards(initCards.filter(card => card.title.toLowerCase().includes(kw)));
    });
  };

  return (
    <main className="container">
      <div className="container_levelFilter">
        <FormControl
          type="search"
          placeholder="Search by Title"
          aria-label="Search"
          onChange={search}
          className="search-field"
          value={searchValue}
        />
        {state.profile.username && (
          <Form.Select
            aria-label="my kata field"
            value={myKata}
            onChange={getMyKata}
            className="container_levelFilter_myKata-field"
          >
            <option value={KataType.ALL}>All Kata</option>
            <option value={KataType.MY}>My Kata</option>
          </Form.Select>
        )}
        <Form.Select
          aria-label="filter field"
          value={level}
          onChange={e => filterByLevel(e.target.value)}
          className="filter-field"
        >
          <option value="">All levels</option>
          {levelList.map((level, index) => (
            <option key={index} value={level.value}>
              {level.label}
            </option>
          ))}
        </Form.Select>
      </div>
      <hr />
      {isLoading ? (
        <Loading />
      ) : (
        <Sections
          setMCards={setMCards}
          myKata={myKata}
          cards={mCards}
          level={level}
          keyword={keyword}
        />
      )}
    </main>
  );
};

export default Home;
